$ = require 'jquery'
AttachmentTypePickerView = require 'app/scripts/views/card/attachment-type-picker-view'
AutoMentionerView = require 'app/scripts/views/internal/autocomplete/auto-mentioner-view'
EmojiCompleterView = require 'app/scripts/views/internal/autocomplete/emoji-completer-view'
ModelLoader = require 'app/scripts/db/model-loader'
PopOver = require 'app/scripts/views/lib/pop-over'
TrelloCompleterView = require 'app/scripts/views/internal/autocomplete/trello-completer-view'
Util = require 'app/scripts/lib/util'
{ track } = require '@trello/analytics'
Promise = require 'bluebird'
_ = require 'underscore'

membersLastLoaded = {}

module.exports = class CompleterUtil

  openEmojiCompleter: (e) ->
    Util.stop(e)

    PopOver.pushView
      view: @getEmojiCompleterView("button")

  openAutoMentioner: (e) ->
    Util.stop(e)

    @getAutoMentionerView("button")
    .then (view) ->
      PopOver.pushView
        view: view

    track("Card Detail", "Mention Autocomplete", "Open Menu - With Click")

  autoMentionerView: (source, card, board) ->
    model = if card? then card else board
    new AutoMentionerView
      model: model
      button: source == 'button'
      input: source == 'input'
      target: @getTextInput()
      card: card
      board: board
      modelCache: @modelCache

  getAutoMentionerView: (source) ->
    # Define source models for both card-detail and description views
    card = if @getCard? then @getCard() else @card
    board = if card then card.getBoard() else @board

    # Load the org members if we haven't done that recently
    if (org = board?.getOrganization())?
      if (!membersLastLoaded[org.id] || Date.now() - membersLastLoaded[org.id] > 5 * 60 * 1000)
        membersLastLoaded[org.id] = Date.now()
        ModelLoader.loadOrganizationMembersData org.id

    # Load board members if modelCache isn't properly populated
    memberships = @modelCache.get('Board', board.id).get('memberships')
    idBoardMemsById = _.indexBy(board.getIdBoardMems())

    if idBoardMemsById.length != memberships.length
      # NOTE: Unfortunately this situation is also triggered by boards that
      # have a deactivated user (which due to a server bug leaves a membership
      # behind for the deleted member)  If we only have deactivated users missing
      # that's not a problem and we don't need to load all the members
      hasUnloadedMembers = memberships.some (membership) ->
        !membership.deactivated &&
        !idBoardMemsById.hasOwnProperty(membership.idMember)

      if hasUnloadedMembers
        return ModelLoader.loadBoardMembers board.id
          .then => @autoMentionerView(source, card, board)

    return Promise.resolve @autoMentionerView(source, card, board)

  getEmojiCompleterView: (source) ->
    card = @getCard()

    new EmojiCompleterView
      model: card
      button: source == 'button'
      input: source == 'input'
      target: @getTextInput()
      card: card
      modelCache: @modelCache

  getTrelloCompleterView: ->
    card = @getCard()

    new TrelloCompleterView
      model: card
      button: true
      target: @getTextInput()
      card: card
      modelCache: @modelCache

  commentAddAttachment: (e) ->
    Util.stop(e)

    $textInput = $(e.target).closest('.comment-box').find('textarea')
    selectionStart = $textInput.prop('selectionStart')
    selectionEnd = $textInput.prop('selectionEnd')
    selectedText = $textInput.val().substring(selectionStart, selectionEnd)

    card = @getCard()

    view = new AttachmentTypePickerView({ @model, @modelCache, defaultName: selectedText })

    view.on 'attach', ({ url, name }) ->
      name = name || selectedText

      replacement =
        if name
          "[#{ name }](#{ url })"
        else
          url
      Util.insertSelection($textInput, "#{ replacement } ", selectionStart, selectionEnd)
      $textInput.trigger('autosize.resize')

    PopOver.toggle
      elem: $(e.currentTarget)
      keepEdits: true
      view: view
      options: { model: card, @modelCache }

    track("Card Detail", "Comment Box - Open Attachment Type Picker")
    return

  commentMentionMember: (e) ->
    Util.stop(e)

    @getAutoMentionerView("button")
    .then (view) ->
      PopOver.toggle
        elem: $(e.currentTarget)
        keepEdits: true
        view: view

    track("Card Detail", "Comment Box - Mention Members")
    return

  commentAddEmoji: (e) ->
    Util.stop(e)

    PopOver.toggle
      elem: $(e.currentTarget)
      keepEdits: true
      view: @getEmojiCompleterView("button")

    track("Card Detail", "Comment Box - Add Emoji")
    return

  commentAddCard: (e) ->
    Util.stop(e)

    PopOver.toggle
      elem: $(e.currentTarget)
      keepEdits: true
      view: @getTrelloCompleterView()

    track("Card Detail", "Comment Box - Add Card")
    return
